import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { CommonStates } from '../../common/types/enums'
import { CommonState, CommonStatePayload } from '../../common/types/types'

const initialState: { data: CommonState } = {
  data: {
    [CommonStates.LOADING]: true,
  },
}

export const commonStateSlice = createSlice({
  name: 'common-state',
  initialState,
  reducers: {
    setCommonState: (state, action: PayloadAction<CommonStatePayload>) => {
      state.data[action.payload.stateName] = action.payload.state
    },
  },
})

export const { setCommonState } = commonStateSlice.actions

// Базовый селектор
export const selectCommonStateData = (state: RootState) => state.commonState.data

// Мемоизированный селектор с параметром
export const selectCommonState = (field: CommonStates) =>
  createSelector([selectCommonStateData], (data) => data[field])

export default commonStateSlice.reducer
